import { useEffect, useState } from "react";
import { BookOpen, Download, Printer, FileText } from "lucide-react";
import { Shell } from "@/components/Shell";
import api from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Help() {
  const [docs, setDocs] = useState(null);
  const [which, setWhich] = useState("manual");

  useEffect(() => {
    api.get("/help/content").then(({ data }) => setDocs(data)).catch(() => setDocs({}));
  }, []);

  const doc = docs?.[which];

  return (
    <Shell bare>
      <div className="max-w-3xl" data-testid="help-page">
        <div className="no-print">
          <p className="overline">Operating manual</p>
          <h1 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tight leading-none mt-2">
            How to run ArkPass
          </h1>

          <div className="flex flex-wrap gap-2 mt-7">
            {[["manual", "Organiser manual", BookOpen], ["door_sheet", "Door sheet", FileText]].map(
              ([key, label, Icon]) => (
                <button
                  key={key}
                  onClick={() => setWhich(key)}
                  className={which === key ? "btn-primary" : "btn-secondary"}
                  data-testid={`help-tab-${key.replace("_", "-")}`}
                >
                  <Icon size={15} /> {label}
                </button>
              )
            )}
          </div>

          <div className="flex flex-wrap gap-3 mt-4">
            <button onClick={() => window.print()} className="btn-secondary" data-testid="help-print-btn">
              <Printer size={15} /> Print this page
            </button>
            <a
              href={`${API}/api/help/${which === "manual" ? "manual" : "door-sheet"}.pdf`}
              className="btn-secondary"
              data-testid="help-pdf-btn"
            >
              <Download size={15} /> Download PDF
            </a>
            <a
              href={`${API}/api/help/${which === "manual" ? "manual" : "door-sheet"}.doc`}
              className="btn-secondary"
              data-testid="help-doc-btn"
            >
              <Download size={15} /> Download Word
            </a>
          </div>
        </div>

        {!doc ? (
          <p className="text-sm text-slate-500 mt-8">Loading…</p>
        ) : (
          <article className="mt-10 print-doc" data-testid="help-content">
            <h2 className="font-display text-2xl font-black uppercase" data-testid="help-doc-title">
              {doc.title}
            </h2>
            <p className="text-sm text-slate-400 mt-1">{doc.subtitle}</p>

            {doc.sections.map((section) => (
              <section key={section.heading} className="mt-9" data-testid="help-section">
                <h3 className="font-display text-lg font-black">{section.heading}</h3>
                {section.intro && <p className="text-sm text-slate-400 mt-2">{section.intro}</p>}
                <ol className="mt-3 space-y-2.5">
                  {section.steps.map((step, i) => (
                    <li key={i} className="flex gap-3 text-sm text-slate-200 leading-relaxed">
                      <span className="font-mono2 text-[11px] text-[#00e599] pt-0.5 shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span>{step}</span>
                    </li>
                  ))}
                </ol>
                {section.shot && (
                  <figure className="mt-4">
                    <img
                      src={`/manual/${section.shot}`}
                      alt={section.heading}
                      loading="lazy"
                      className="w-full rounded-xl border border-[#28323f]"
                      data-testid={`help-shot-${section.shot.slice(0, 2)}`}
                    />
                    <figcaption className="font-mono2 text-[10px] text-slate-500 mt-2">
                      Screen: {section.heading}
                    </figcaption>
                  </figure>
                )}
              </section>
            ))}
          </article>
        )}
      </div>
    </Shell>
  );
}
